const polyfill = [];

if (
  typeof window !== 'undefined' &&
  !(
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
    'isIntersecting' in window.IntersectionObserverEntry.prototype
  )
) {
  polyfill.push(
    import(
      /* webpackChunkName: "polyfill-intersection-observer" */ 'intersection-observer'
    )
  );
}

export default polyfill;
